export default __webpack_public_path__ + "static/media/hoohoo.8daf85ab.svg";